import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
/**
 * Reconciles upload progress with the locally tracked files while preventing late async updates
 * from restoring attachments that the user already removed.
 */
export function mergeUploadChanges({ changedFiles, current, removedIds, }) {
    return changedFiles.reduce((files, changedFile) => {
        if (removedIds.has(changedFile.id))
            return files;
        const existingIndex = files.findIndex((file) => file.id === changedFile.id);
        if (existingIndex < 0)
            return [...files, changedFile];
        return files.map((file, index) => (index === existingIndex ? changedFile : file));
    }, current);
}
export function createHydratedFileAttachment({ filename, mimeType, url, }) {
    const file = new File([], filename, mimeType === undefined ? undefined : { type: mimeType });
    return {
        id: safeRandomUUID(),
        file,
        fileName: filename,
        fileSize: file.size,
        fileType: file.type,
        previewTarget: { kind: 'local', file },
        status: 'success',
        url,
    };
}
/** A concrete parser rejection removes the stored attachment; a lost response does not. */
export function isRejectedStoredUpload(file) {
    return (file.status === 'failed' &&
        file.url !== undefined &&
        file.failureCode !== undefined &&
        file.failureCode !== 'client_no_response');
}
//# sourceMappingURL=fileAttachmentUpdates.js.map